import { Dispatch, SetStateAction, useState } from 'react';
import { useQuery } from 'react-query';

import { useOrdersReportApi } from '@hooks/api';

import config from '../config';

import type { QueryKey } from 'react-query';
import type { OrderSearchRequest } from '@goodfynd/types';
import type { OrdersReportCustomerOverviewResponse } from '../services/api/types';
type ReportCustomerOverviewOptions = {
  onError?: (err: unknown) => void;
  onSuccess?: (
    data: OrdersReportCustomerOverviewResponse,
    toggleBusy: Dispatch<SetStateAction<boolean>>
  ) => void;
  queryKey?: QueryKey;
  refetchInterval?: number;
  refetchOnWindowFocus?: boolean;
  request: OrderSearchRequest;
  updateSearch?: () => void;
};

export function useReportCustomerOverview({
  onError,
  onSuccess,
  queryKey = config.queryKeys.ordersReportTrend,
  refetchInterval,
  refetchOnWindowFocus = false,
  request,
}: ReportCustomerOverviewOptions) {
  const api = useOrdersReportApi();
  const [busy, toggleBusy] = useState(false);

  const { data, isError, isFetched, isFetching, isLoading, refetch } = useQuery<
    OrdersReportCustomerOverviewResponse,
    unknown
  >(
    [queryKey, request],
    async () => {
      return await api.customerOverview(request);
    },
    {
      enabled: !!request,
      onError,
      onSuccess(data) {
        onSuccess?.(data, toggleBusy);
      },
      refetchInterval,
      refetchOnWindowFocus,
    }
  );

  return {
    data,
    isError,
    isFetched,
    isFetching: isFetching || busy,
    isLoading,
    refetch,
  };
}
